<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="20%"
      :show-close="false"
      append-to-body
      top="30vh"
    >
      <div class="main__container">
        <img
          class="close"
          src="./img/delete.png"
          alt=""
          @click.stop="handlerClose"
        />

        <h1 class="title">选择上门服务时间</h1>
        <div class="component-patrol-time">
          <div
            class="item mb-4 cursor-pointer"
            v-for="item in list"
            :key="item.id"
            @click="handleClickItem(item)"
          >
            <div
              :class="{ active: currentItem.id == item.id }"
              class="flex pl-2 pr-2 items-center justify-between item"
            >
              <div>{{ item.date.split(" ")[0] }}</div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <ComponentPatrolDetail
      :show.sync="visibleDetail"
      :detail="archivesDetail"
      :id="currentItem.id"
      :sn="sn"
    ></ComponentPatrolDetail>
    <ComponentUserOrderDetail
      :show.sync="visibleOrder"
      :detail="archivesDetail"
      :id="currentItem.id"
      :sn="sn"
    ></ComponentUserOrderDetail>
  </div>
</template>
<script>
import ComponentPatrolDetail from "./PatrolDetail.vue";
import ComponentUserOrderDetail from "./UserOrderDetail.vue";

export default {
  data() {
    return {
      currentItem: {},
      visibleDetail: false,
      visibleOrder: false,
    };
  },
  components: {
    ComponentPatrolDetail,
    ComponentUserOrderDetail,
  },
  props: {
    show: Boolean,
    list: {
      type: Array,
      default: () => [],
    },
    archivesDetail: {
      type: Object,
      default: () => {},
    },
    sn: {
      type: String,
      default: "",
    },
  },
  watch: {
    show(n) {
      if (n) {
        this.currentItem = {};
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        this.$emit("update:show", n);
      },
    },
  },
  methods: {
    handlerClose() {
      this.visible = false;
    },
    handleClickItem(item) {
      this.visible = false;
      this.currentItem = item;
      if (item.type) {
        this.visibleOrder = true;
      } else {
        this.visibleDetail = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.main__container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}
.component-patrol-time {
  width: 100%;
  color: #fff;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0px;
  top: -40px;
  z-index: 11111;
  cursor: pointer;
}

.title {
  position: absolute;
  left: 0px;
  top: -50px;
  z-index: 11111;
  color: #333;
  font-size: 26px;
}
.item {
  width: 100%;
  height: 39px;
  // background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
  //   opacity: 0.28;

  font-size: 16px;
  color: #01b3e6;
  font-weight: 500;
}
.item:hover {
  color: #fff;
  background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
}
.active {
  color: #fff;
  background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
}
::v-deep {
  .el-dialog {
    // // 取消阴影和背景色
    // background: rgba(0, 0, 0, 0);
    // // background: #070b16;
    // -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
    // //   backdrop-filter: blur(10px);
    // backdrop-filter: blur(10px);

    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
    // border: 1px solid #4bace0;
    // border-radius: 10px;
    border-radius: 10px;
  }
}
</style>
